// extracted by mini-css-extract-plugin
export default {"homeside":"homeside_homeside__+AYoY","homeside-top":"homeside_homeside-top__zU1uu","arrow-round":"homeside_arrow-round__BgMsQ"};